// Import react elements
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

// Import context function
import { AuthContext } from "global/context/AuthContext";

// Import icons
import { ShowAllIcon } from "global/strich_icons/StrichIcons";

// Import core functions
import { resendActivationEmail } from "api/APICoreCalls";

// Import components
import CreateButton from "global/components/CreateButton";

// Import utility functions
import { DisplayConfirmationDialog } from "global/utilities/DialogBox";
import { GetCookie, SetCookie } from "global/utilities/Cookies"

// Import css style sheet
import styles from "../LoginPage.module.css";

const LoginForm = ({ onSwitch }) => {



    // Set the prefill_email with the prefill_email_cookie
    const prefill_email = GetCookie("prefill_email");



    // Extract the `login` function from the authentication context - allows us to call `login()` anywhere inside this component without needing to manually pass it down as a prop
    const { login } = useContext(AuthContext);



    // Set navigate to useNavigate() which provides a function to programmatically navigate between routes
    const navigate = useNavigate();



    // Set the defualt form values
    const [email, setEmail] = useState(prefill_email || "");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [resendingActivation, setResendingActivation] = useState(false);
    const [showResendActivation, setShowResendActivation] = useState(false);



    // Handle the submit button on login form
    const handleSubmitLogin = async (event) => {

        // Prevent page reload
        event.preventDefault();

        // Run the api call
        const response = await login(email, password);

        // Check if the response is successful
        if (response.success) {

            // It is

            // Hide the resend activation option
            setShowResendActivation(false);

            // Set prefill_email cookie to the user's email
            SetCookie("prefill_email", email, 1);

            // Navigate to the dashboard
            navigate("/dashboard"); // Redirect after login

        } else {

            // It isn't

            // Set the 'error' value in the form so it can be displayed to the user
            setError(response.error_message);

            // Only offer to resend the activation email when the API says the account is not activated
            setShowResendActivation(response.error_message === "Account has not been activated");

        }

    };



    // Resend the account activation email
    const handleResendActivationEmail = async () => {

        // The existing login email field supplies the address
        if (!email || !email.includes("@")) {

            setError("Enter your email address above first.");

            return;

        }

        // Prevent repeated clicks while the request is running
        setResendingActivation(true);

        // Clear any previous login error
        setError("");

        // Request another activation email
        const response = await resendActivationEmail(email);

        // Request has finished
        setResendingActivation(false);

        // Show any genuine send/network failure
        if (!response.success) {

            setError(response.error_message || "Unable to resend the activation email.");

            return;

        }

        // Use a deliberately generic confirmation so account existence is not exposed
        DisplayConfirmationDialog(

            "We've sent you a new activation email. Be sure to check your spam or junk folder.",

            "OK",

            ""

        );

    };

    

    return (

        <div>

            <form onSubmit={handleSubmitLogin}>

                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={(event) => {
                        setEmail(event.target.value);
                        setShowResendActivation(false);
                    }}
                    required
                    value={email || ""}
                />

                <br />
                <br />

                <div className={styles.login_password_input_wrap}>

                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        required
                    />

                    <button
                        type="button"
                        className={styles.login_password_toggle}
                        onClick={() => setShowPassword(!showPassword)}
                        title={showPassword ? "Hide password" : "Show password"}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                        <ShowAllIcon />
                    </button>

                </div>

                <br />
                <br />

                <p>
                    <span onClick={() => onSwitch("reset-password")} style={{ cursor: "pointer" }}><b>Forgotten Password?</b></span>
                </p>

                <br />

                {error && <p style={{ color: "red" }}>{error}</p>}

                {showResendActivation &&

                    <p>
                        <span
                            onClick={resendingActivation ? undefined : handleResendActivationEmail}
                            style={{ cursor: resendingActivation ? "default" : "pointer" }}
                        >
                            <b>{resendingActivation ? "Sending activation email..." : "Didn't receive your activation email? Resend it"}</b>
                        </span>
                    </p>

                }

                <br />

                <CreateButton title="Login" size="l" fullWidth="true" color="#1597e5" type="submit" />
                
            </form>

            <br />
            

            <p>
                Don't have an account? <span onClick={() => onSwitch("register")} style={{ cursor: "pointer" }}><b>Sign Up</b></span>
            </p>

        </div>
        
    );

};

export default LoginForm;